import { ContentPanel, RootContainer, SidebarPanel } from './styled';
export function Root(props) {
    const { sidebar, content } = props;
    return (<RootContainer>
      <SidebarPanel>{sidebar}</SidebarPanel>
      <ContentPanel>{content}</ContentPanel>
    </RootContainer>);
}
